module.exports = __webpack_public_path__ + "img/sld_abt_meter_t1_dark.0bab6214.svg";